module.exports = __webpack_public_path__ + "img/wordpress.bae85200.svg";